import { Controller } from 'stimulus';
import { useWindowResize, useDispatch, useDebounce } from 'stimulus-use';
import { gsap } from 'gsap';
import { getBreakpointValue, getCurrentBreakpoint, isMinBreakpoint } from '../tailwindhelpers';

export default class extends Controller {
  static targets = ['header', 'body', 'screenheader', 'mdScreenheader', 'pheader', 'menuItem', 'menuItemLink'];
  static values = {intro: Boolean};
  static debounces = ['watchBreakpointChange'];

  connect() {
    useDispatch(this);
    useDebounce(this);
    useWindowResize(this)
    this.animationFinished = false;
    if (!document.referrer.match(/localhost|lab.capitale/) && this.hasIntroValue && this.introValue) {
      this.introAnimation.play();
    } else {
      this.done();
    }
  }

  windowResize({ height, width }) {
    this.writeScreenHeaderSize();
    this.mdWriteScreenHeaderSize(width);
    this.writeCssVars(); 
    this.writePheader();
    this.watchBreakpointChange();
  }

  done() {
    this.animationFinished = true;
    document.getElementById('content').style.opacity = 1;
    window.dispatchEvent(new Event('global:animation-done'));
  }

  writeScreenHeaderSize() {
    const screenHeight = window.innerHeight - this.headerTarget.getBoundingClientRect().height; 
    window.screenHeight = screenHeight;
    this.screenheaderTargets.forEach((t) => {
      t.style.height = `${screenHeight}px`;
    })
  }

  mdWriteScreenHeaderSize(width) {
    if (isMinBreakpoint(width, 'md')) {
      const screenHeight = window.innerHeight - this.headerTarget.getBoundingClientRect().height; 
      window.screenHeight = screenHeight;
      this.mdScreenheaderTargets.forEach((t) => {
        t.style.height = `${screenHeight}px`;
      }) 
    }
  }

  writePheader() {
    this.pheaderTargets.forEach((t) => {
      t.style.paddingTop = `${this.headerTarget.getBoundingClientRect().height}px`;
    })
  }

  writeCssVars() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`); 
    document.documentElement.style.setProperty(
      '--header-height',
      document.querySelector('body > header').getBoundingClientRect().height + 'px'
      ) 
  }

  get introAnimation() {
    const introTL = gsap.timeline({
      paused: true,
      defaults: {
        duration: .5,
        ease: 'none',
        onComplete: this.done,
      },
    }) 
    .set(this.menuItemTargets[2], {
      display: 'none',
    })
    .addLabel('start', 1.5)
    .from('.header', { 
      paddingBottom: 0,
      paddingTop: 0,
      borderBottomWidth: '0',
      height: '100%', 
      zIndex: 30,
    }, 'start') 
    .from([this.menuItemTargets[0], this.menuItemTargets[1]], { 
      fontSize: window.innerWidth >= getBreakpointValue('md') ?
        'clamp(2rem, 12rem, 25vh)' :
        'clamp(2rem, 5rem, 100vw)',
      //fontSize: '12rem',
      lineHeight: '30vh',
      height: '50vh',
      display: 'flex',
      alignItems: 'center',
    }, 'start')
    .from(this.menuItemTargets[0], {
      borderBottom: '4px solid',
    }, 'start')
    .to(this.menuItemTargets[2], {
      delay: 0,
      display: 'block',
    })
    .to(this.bodyTarget, {
      delay: 0,
      opacity: 1,
    })
    .addLabel('end')
    .to('.header', {
      style: '',
    }, 'end')
    .to(this.menuItemTargets, {
      style: '',
    }, 'end')

    return introTL;
  } 

  setFullHeight() {
    this.element.style.height = `${window.innerHeight}px`;
    this.bodyTarget.style.height = `${window.innerHeight}px`;
    this.bodyTarget.style.overflow = 'hidden';
  }

  get isInternal() {
    const referrer = document.referrer;
    const host = window.location.hostname;
    return referrer.length > 0 && referrer.includes(host);
  }

  setTurbo() {
    window.turboNavigation = true;
  }

  watchBreakpointChange(width) {
    this.currentBreakpoint  = '';
    this.newBreakpoint = getCurrentBreakpoint(width);

    if (this.currentBreakpoint != this.newBreakpoint) {
      this.dispatch('breakPointChange');
      this.currentBreakpoint = this.newBreakpoint; 
    }

  }
}
